export default "__VITE_ASSET__Btp0Sz3J__"